"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Region = void 0;
var create_entity_1 = require("../../utils/create-entity");
var gql = String.raw;
exports.Region = {
  name: 'Region',
  autoRoutes: ['list', 'create', 'update'],
  useSlices: true,
  table: {
    fieldNames: ["info", "economy", "dataSetId"]
  },
  sectionName: 'Places',
  filters: {
    fields: {
      economy: {
        entityTypeName: 'Economy'
      }
    }
  },
  list: {
    resultsVariant: 'table'
  },
  form: {
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      description: {
        type: 'longText'
      },
      dataSetId: {
        type: 'text',
        description: "Specify an ID to uniquely identify this {{REGION}}. This might be useful to tie this {{REGION}} to values coming from an external API, for example",
        recommended: false,
        monospace: true
      },
      economy: {
        type: 'linked',
        entityTypeName: 'Economy',
        label: 'Country',
        description: "Is there a {{ECONOMY}} which encloses this region?"
      }
    })
  }
};